export default function contentLists() {
  return {
    free: gon.contents.filter((content) => content.type === 'free'),
    paid: gon.contents.filter((content) => content.type === 'paid'),
  }
}
